import React, { createRef, useState, useEffect, useRef } from "react";
import { TextField, Paper, Button } from "react-md";
import { ReactSVG } from "react-svg";
import "../../../../../css/VectorStyles.scss";
import "../style.css"
import arrowSVG from "../../../../../images/vectors/up-right-arrow.svg";
import dotSVG from "../../../../../images/vectors/dot.svg";
import Canvas from "../../../../../components/vectors/canvas";
import MathJax from "../../../../../components/react-mathjax-preview";
import VectorParser from "../../../../../lib/vector-math-parser";
import { Checkbox, FormControlLabel, IconButton, Radio, Tooltip } from "@mui/material";
import { DEFAULT_VECTOR_SNAP_TO_GIRD } from "../../../../../common/constants";
import SFVectorInput from "../SFVectorInput";
import SFTooltip from "../SFTooltip";
import { IoInformationCircleSharp } from "react-icons/io5";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";

const SFVectorTypeAnswer = ({
    answers,
    variableMap,
    answerType,
    selectedAnswer,
    onAnswerChoice,
    vectorSettings,
    showVectorAnswer,
    correctAnswerVectors,
    vectorAnswerFormulas,
    currentQuestionID,
    freeFormVectorOptions,
    numOfColumns,
    showAnswerResponse,
    answerCorrect,
    count,
    compact,
    selectedAnswers,
    question_attempt,
    alreadyPickedAnswer
}) => {

    const [localValue, setLocalValue] = useState(""); // for radio
    const [localValueArr, setLocalValueArr] = useState([]); // for checkbox

    const [vectors, setVectorss] = useState([]);
    useEffect(() => {
        if (answers && answerType !== 2) {
            setVectorss(
                answers.map((answer, index) => {
                    const vectorAns = VectorParser.generateAnswerVector(
                        answer.vectorAnswerFormula,
                        variableMap,
                        vectorSettings
                    );
                    return vectorAns;
                })
            );
        }
        console.debug("answers", answers)
    }, [answers, count, question_attempt]);

    useEffect(() => {
        setLocalValue("")
        setLocalValueArr([])
    }, [selectedAnswers,selectedAnswer,question_attempt]);

    const onAnswerClick = (event, index) => {
        //event.preventDefault();
        onAnswerChoice(answers[index].answer_id);
    };
    const onFreeResponseAnswer = (vectorAnswer, index) => {
        console.log("selectedAnswer,vectorAnswer", selectedAnswer, vectorAnswer);
        onAnswerChoice({ ...vectorAnswer });
    };

    const removeElementFromArray = (arr, element) => {
        var i = arr.indexOf(element);
        if (i !== -1) {
            arr.splice(i, 1);
        }
        ////console.log("questionIds Array value =",arr);
        return arr;
    }

    if (answerType === 2 || answerType === 90) {
        return (
            <FreeFormVectorAnswer
                vectorSettings={vectorSettings}
                onAnswerChange={onFreeResponseAnswer}
                showVectorAnswer={showVectorAnswer}
                correctAnswerVectors={correctAnswerVectors}
                vectorAnswerFormulas={vectorAnswerFormulas}
                currentQuestionID={currentQuestionID}
                freeFormVectorOptions={freeFormVectorOptions}
                showAnswerResponse={showAnswerResponse}
                answerCorrect={answerCorrect}
                count={count}
                answerType={answerType}
                selectedAnswers={selectedAnswers}
                question_attempt={question_attempt}
                alreadyPickedAnswer={alreadyPickedAnswer}
            />
        );
    }

    return (
        <div>
            <div className="mb-2">Select your {answerType === 0 ? "answer" : (answerType !== 2) ? "answers" : ""}:</div>
            <div style={{
                display: 'grid',
                gridTemplateColumns: window.innerWidth < 900 || numOfColumns === 1 ? 'auto' : 'auto auto'
            }}>
                {vectors.map((vector, index) => {
                    let selectedClassName = "";
                    let correctClassName = ""
                    if (answers[index] !== undefined) {
                        if (answerType === 0) {
                            if (selectedAnswer === answers[index].answer_id 
                                ||
                                (answers[index] !== undefined &&
                                    answers[index].isChecked !== undefined &&
                                    answers[index].isChecked)
                                || localValue === answers[index].answer_id 
                            ) {
                                selectedClassName = "sf-ans-btn-selected"
                                if (showAnswerResponse) {
                                    if (answerCorrect) {
                                        correctClassName = "sf-vector-correct"
                                    } else {
                                        correctClassName = "sf-vector-incorrect"
                                    }
                                }
                            }
                            
                        } else if (answerType === 1) {
                            console.debug("selectedAnswer>>>", selectedAnswer, answerCorrect)
                            if (
                                selectedAnswer.includes(answers[index].answer_id) 
                                ||
                                (answers[index] !== undefined &&
                                    answers[index].isChecked !== undefined &&
                                    answers[index].isChecked)
                                || localValueArr.includes(answers[index].answer_id)
                            ) {
                                selectedClassName = "sf-ans-btn-selected"
                                if (showAnswerResponse) {
                                    if (answerCorrect) {
                                        correctClassName = "sf-vector-correct"
                                    } else {
                                        correctClassName = "sf-vector-incorrect"
                                    }
                                }
                            }
                           
                        }
                    }
                    
                    if (answers === null || answers === undefined || answers[index] === null || answers[index] === undefined) return
                    return (
                        <div
                            tabIndex={0}
                            role={answerType === 0 ? 'radio' : 'checkbox'}
                            aria-checked={selectedClassName !== ''}
                            aria-label={`Vector answer option ${index + 1}`}
                            onKeyDown={(event) => {
                                if (event.key === ' ' || event.key === 'Enter') {
                                    event.preventDefault();
                                    event.currentTarget.click();
                                }
                            }}
                            onClick={(event) => {
                                if (answerType === 0) {
                                    setLocalValue(answers[index].answer_id);
                                } else if (answerType === 2) {

                                } else { // checkbox
                                    let newLocalValueArr = localValueArr;
                                    if (newLocalValueArr.includes(answers[index].answer_id)) {
                                        newLocalValueArr = removeElementFromArray(newLocalValueArr, answers[index].answer_id)
                                    } else {
                                        newLocalValueArr.push(answers[index].answer_id)
                                    }
                                    setLocalValueArr([...newLocalValueArr]);
                                }
                                onAnswerClick(event, index);
                            }} //(checked) =>{props.onAnswerChoice(checked,{qID:question.id,aID:index.toString()})}
                            // className="vector-answer-container"
                            className={`sf-ans-btn cursor-pointer sf-vector-ans 
                                 ${selectedClassName} 
                                ${correctClassName}`}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignItems: "center",
                            }}
                        >
                            {answerType === 0 ? (
                                <Radio
                                    id={"input" + index}
                                    // hidden={!compact}
                                    hidden
                                    checked={
                                        (answers[index] !== undefined &&
                                            selectedAnswer == answers[index].answer_id) ||
                                            (answers[index] !== undefined &&
                                                answers[index].isChecked !== undefined &&
                                                answers[index].isChecked)
                                            || (localValue === answers[index].answer_id)
                                            ? true
                                            : false
                                    }
                                />
                                // <input
                                //     checked={
                                //         (answers[index] !== undefined &&
                                //             selectedAnswer == answers[index].answer_id) ||
                                //             (answers[index] !== undefined &&
                                //                 answers[index].isChecked !== undefined &&
                                //                 answers[index].isChecked)
                                //             ? true
                                //             : false
                                //     }
                                //     style={{ marginRight: "20px" }}
                                //     id={"input" + index}
                                //     type={"radio"}
                                // />
                            ) : answerType === 2 ? (
                                ""
                            ) : (
                                <Checkbox
                                    id={"input" + index}
                                    // hidden={!compact}
                                    hidden
                                    checked={
                                        (answers[index] !== undefined &&
                                            selectedAnswer !== undefined &&
                                            selectedAnswer.includes(answers[index].answer_id)) ||
                                            (answers[index] !== undefined &&
                                                answers[index].isChecked !== undefined &&
                                                answers[index].isChecked)
                                            || (localValueArr.includes(answers[index].answer_id))
                                            ? true
                                            : false
                                    }
                                />
                                // <input
                                //     checked={
                                //         (answers[index] !== undefined &&
                                //             selectedAnswer !== undefined &&
                                //             selectedAnswer.includes(answers[index].answer_id)) ||
                                //             (answers[index] !== undefined &&
                                //                 answers[index].isChecked !== undefined &&
                                //                 answers[index].isChecked)
                                //             ? true
                                //             : false
                                //     }
                                //     style={{ marginRight: "20px" }}
                                //     id={"input" + index}
                                //     type={"checkbox"}
                                // />
                            )}
                            <VectorAnswer
                                key={"vector-answer" + index}
                                vector={vector}
                                vectorSettings={vectorSettings}
                                readOnly={answerType !== 2}
                                answerType={answerType}
                                vectorAnswerFormula={answers[index] ? answers[index].vectorAnswerFormula : null}
                                currentQuestionID={currentQuestionID}
                            />
                        </div>
                    );
                })}
            </div>
        </div>

    );
};

const VectorAnswer = ({ vector, vectorSettings, readOnly = true, answerType, vectorAnswerFormula, currentQuestionID }) => {
    const canvasRef = createRef();
    useEffect(() => {
        if (canvasRef && canvasRef.current && vector)
            console.debug("vector>>??", vector)
            canvasRef.current.drawVectors({ vectors: [vector] });
    }, [vector, canvasRef]);

    console.log(`Point 0 ::: Vector Anas Grid Settings Data => `, vectorSettings);
    return (
        <Canvas
            answerType={answerType}
            type="answer"
            onVectorMoved={() => console.log("onVectorMoved")}
            ref={canvasRef}
            degStepSize={5}
            magStepSize={1}
            stepDeg={false}
            readOnly={readOnly}
            isAnswer={true}
            height={vectorSettings.height}
            width={vectorSettings.width}
            rulerXPoint={vectorSettings.rulerXPoint}
            rulerYPoint={vectorSettings.rulerYPoint}
            stepSize={vectorSettings.stepSize}
            enableGrid={vectorSettings.enableGrid}
            enableBorder={vectorSettings.enableBorder}
            enableRuler={vectorSettings.enableRuler}
            enableDarkGridLine={vectorSettings.enableDarkGridLine}
            freeBodyDiagram={vectorSettings.image}
            fbdWidth={vectorSettings.stepSize * vectorSettings.imageWidthUnit}
            fbdHeight={vectorSettings.stepSize * vectorSettings.imageHeightUnit}
            fbdX={vectorSettings.imageX}
            fbdY={vectorSettings.imageY}
            gridColor={vectorSettings.gridColor}
            rulerXLabel={vectorSettings.rulerXLabel}
            rulerYLabel={vectorSettings.rulerYLabel}
            rulerNXLabel={vectorSettings.rulerNXLabel}
            rulerNYLabel={vectorSettings.rulerNYLabel}
            commonVectorSettings={vectorSettings}
            showScale={vectorSettings.showScale}
            scale={vectorSettings.scale}
            vectorAnswerFormula={vectorAnswerFormula}
            currentQuestionID={currentQuestionID}
        ></Canvas>
    );
};

const vectorInitValue = {
    x: 5,
    y: 5,
    strokeWidth: 5,
    name: "ans",
    posX: "5",
    posY: "5",
    color: "#0aaafa",
    angleOptions: {
        angleOffset: 0,
        type: 1,
    },
    angle: 45.0,
    mag: 7.1,
    index: 1,
    initializedIndex: 0
};
const colorPallete = [
    "#F79722",
    "#0AAAFA",
    "#FF5500",
    "#09B83E",
    "#34465D",
    "#E4405F",
];

const FreeFormVectorAnswer = ({
    vectorSettings,
    onAnswerChange,
    showVectorAnswer,
    correctAnswerVectors,
    vectorAnswerFormulas,
    currentQuestionID,
    freeFormVectorOptions,
    showAnswerResponse,
    answerCorrect,
    count,
    answerType,
    selectedAnswers,
    question_attempt,
    alreadyPickedAnswer
}) => {

    const canvasRef = createRef();
    const [showImage, setShowImage] = useState(false);
    const [vectors, setVectors] = useState([]);
    const [vectorsCheckbox, setVectorsCheckbox] = useState([]);
    const [zeroVectorsCheckbox, setZeroVectorsCheckbox] = useState([]);
    const [clickedBox, setClickedBox] = useState([]);
    const [planeType, setPlaneType] = useState(null);
    const [isInPlane, setIsInPlane] = useState(false);
    const [isOutPlane, setIsOutPlane] = useState(false);
    const [isZeroVector, setIsZeroVector] = useState(false);
    const [showQuestionVectorPrompt, setShowQuestionVectorPrompt] = useState(false);
    const [isAngleOrMagnitudeTextFieldChanged, setIsAngelOrMagnitudeTextFieldChanged] = useState(false);
    const [snapToGrid, setSnapToGrid] = useState(true);

    const focusIndex = useRef(null);
    const liveVectorCallbacksRef = useRef({});

    useEffect(() => {
        if (canvasRef && canvasRef.current && vectors) {
            canvasRef.current.drawVectors({ vectors:vectors });
        } else {
            canvasRef.current.drawVectors({ vectors: [] });
        }
    }, [canvasRef, vectors]);

    useEffect(() => {
        setShowQuestionVectorPrompt(freeFormVectorOptions.default_checked_vector_prompt ?? false)
    }, [freeFormVectorOptions.default_checked_vector_prompt])

    useEffect(() => {
        if (vectorSettings.showStudentSnapToGridTickbox) {
            setSnapToGrid(vectorSettings.defaultCheckedStudentSnapToGridTickbox);
        } else {
            setSnapToGrid(!vectorSettings.isStudentViewSnapToGridOff);
        }
  }, [vectorSettings])

    useEffect(() => {
        console.debug("selectedAnswers >>?? FreeFormVectorAnswer", selectedAnswers, question_attempt)
        if (selectedAnswers && typeof selectedAnswers === 'object') {
            let vectorValues = Object.values(selectedAnswers);
            console.debug("vectorValues>>??",vectorValues, vectorAnswerFormulas)
            let checkedValues = [];
            let zeroValues = [];
            vectorAnswerFormulas.forEach((formula, index) => {
                let v = vectorValues.find(vec => vec.name === formula.name);
                if (formula.name === v?.name) {
                    checkedValues.push(true);
                    // check if vector x and y is zero
                    let v = vectorValues[index];
                    if ((v?.x === 0 && v?.y === 0)) {
                        zeroValues.push(true);
                    } else {
                        zeroValues.push(false);
                    }
                } else {
                    checkedValues.push(false);
                }
            })
            console.debug("checkedValues>>>", checkedValues, zeroValues)
            setVectors(vectorValues);
            setZeroVectorsCheckbox(zeroValues)
            setVectorsCheckbox(checkedValues)
        } else {
            setVectors([]);
            setClickedBox([]);
            let checkedValues = []
            let _showImage = false;
            vectorAnswerFormulas.forEach((formula) => {
                if (formula.showImage)
                    _showImage = true;

                checkedValues.push(false);
            });
            setShowImage(_showImage);
            setVectorsCheckbox(checkedValues)
        }
        
        
        // setShowQuestionVectorPrompt(false);
    }, [currentQuestionID, count, question_attempt, alreadyPickedAnswer]);

    const onChange = (arg, type) => {
        console.debug("arg>>>>>>>>>>>>>>", arg, vectors)
        onVectorMoved(arg);
        if (type === "angleMag") {
            setIsAngelOrMagnitudeTextFieldChanged(true);
        } else {
            setIsAngelOrMagnitudeTextFieldChanged(false);
        }
    }

    const handleAngleMagnitudeTextFieldChange = (val) => {
        setIsAngelOrMagnitudeTextFieldChanged(val);
    }

    const onVectorMoved = (vectorArg) => {
        const cb = liveVectorCallbacksRef.current[vectorArg.name];
        if (cb) cb(null);
        let targetIndex = vectors.findIndex(vec => vec.name === vectorArg.name)
        const { posX, posY, x, y } = vectorArg;
        const _vectors = vectors.map((_vector, index) => {
            if (targetIndex === index) {
                focusIndex.current = index;
                return { ...vectorArg, posY, posX, x, y };
            } else {
                return { ..._vector };
            }
        });
        console.debug("_vectors----", _vectors, selectedAnswers)
        setVectors(_vectors);
        onAnswerChange(_vectors);
    };

    const onVectorLiveUpdate = (vectorData) => {
        const cb = liveVectorCallbacksRef.current[vectorData.name];
        if (cb) cb(vectorData);
    };

    useEffect(() => {
        if (showVectorAnswer && correctAnswerVectors) {
            setVectors([...Object.values(correctAnswerVectors)]);
        }
    }, [correctAnswerVectors, showVectorAnswer]);
    useEffect(()=> {
        let vectorValues = Object.values(selectedAnswers);
        console.debug("vectorValues<<<<<<<<", vectorValues, vectorAnswerFormulas)
        if (vectorAnswerFormulas && vectorAnswerFormulas.length > 0 ){
          let tempVectors =[]
          for(let index=0;index < vectorAnswerFormulas.length; index++) {
            let vectorAnswer =vectorAnswerFormulas[index]
            // console.debug("vectorAnswer...........", index, vectorAnswerFormulas[index], vectorValues[index])
            if (vectorAnswer?.isStaticVector ) {
              const vector = VectorParser.buildQuestionVariablesMap([vectorAnswer]);
              let staticVector = VectorParser.generateAnswerVector(vectorAnswer, vector, vectorSettings);
          
              if (staticVector) {
                  staticVector.isStaticVector = vectorAnswer.isStaticVector
                  staticVector.isIncorrectAnswer = vectorAnswer.isIncorrectAnswer
                  staticVector = {
                    ...staticVector,
                    isStaticVector:vectorAnswer.isStaticVector,
                    isIncorrectAnswer:vectorAnswer.isIncorrectAnswer,
                    name: vectorAnswer.name,
                    color:vectorAnswer.formulaColor,
                    showComponents:vectorAnswer.showComponents,
                    showAngle:vectorAnswer.showAngle,
                    index:index,
                    initializedIndex:index
                  }
                  if (!vectorAnswer.autoOrigin) {
                    staticVector.posX = vectorAnswer.xOrigin;
                    staticVector.posY = vectorAnswer.yOrigin;
                  }
                  tempVectors.push(staticVector);
              }
          } else {
            if (vectorValues[index]) {
                tempVectors.push(vectorValues[index]);    
            }
            
          }
          console.debug("tempVectors>>>>?????", tempVectors)
          }
          setVectors([...Object.values(tempVectors)]);
          setClickedBox([...Object.values(tempVectors)]);
          let checkedValues = []
          vectorAnswerFormulas?.forEach((formula, index) => {
            let v = vectorValues.find(vec => vec.name === formula.name);
            if(formula?.isStaticVector || formula.name === v?.name){
                //set static vector as checked
                checkedValues.push(true)
            }else {
                checkedValues.push(false);
            }
  
          });
          setVectorsCheckbox(checkedValues)
        }
      },[currentQuestionID,count])
    useEffect(() => {
        window.addEventListener("keydown", keyDownEventFunction);
        return () => window.removeEventListener("keydown", keyDownEventFunction);
    }, []);

    const keyDownEventFunction = (e) => {
        // console.debug("keyDownEventFunction called", e);
        if (e.shiftKey && (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "ArrowUp" || e.key === "ArrowDown")) {
            switch (e.key) {
                case "ArrowLeft":
                    e.preventDefault();
                    ShiftArrowLeftPressed();
                    break;
                case "ArrowRight":
                    e.preventDefault();
                    ShiftArrowRightPressed();
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    ShiftArrowUpPressed();
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    ShiftArrowDownPressed();
                    break;
            }
        } else {
            switch (e.key) {
                case "ArrowLeft":
                    e.preventDefault();
                    ArrowLeftPressed();
                    break;
                case "ArrowRight":
                    e.preventDefault();
                    ArrowRightPressed();
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    ArrowUpPressed();
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    ArrowDownPressed();
                    break;
            }
        }
        return
    }


    const onZeroVectorCheckboxClicked = (event, pickedVectorIndex) => {
        console.log("zero vector", pickedVectorIndex)
        setIsZeroVector(event.target.checked);
        setPlaneType("");
        setIsInPlane(false);
        setIsOutPlane(false);
        if (event.target.checked) {
            const _vectors = vectors.map((_vector, index) => {
                if (_vector?.initializedIndex === pickedVectorIndex) {
                    return { ..._vector, x: 0, y: 0, plane: '' }
                } else {
                    return _vector
                }
            })
            setVectors([..._vectors]);
            onAnswerChange(_vectors);
        } else {
            const _vectors = vectors.map((_vector, index) => {
                if (_vector?.initializedIndex  === pickedVectorIndex) {
                    return { ..._vector, x: Math.trunc(parseInt(vectorSettings.widthUnit) / 2), y: Math.trunc(parseInt(vectorSettings.heightUnit) / 2) }
                } else {
                    return _vector
                }
            })
            setVectors([..._vectors]);
            onAnswerChange(_vectors);
        }

        let tempZeroVectorsCheckbox = zeroVectorsCheckbox;
        tempZeroVectorsCheckbox[pickedVectorIndex] = event.target.checked;
        setZeroVectorsCheckbox([...tempZeroVectorsCheckbox])
    }

    const onVectorCheckboxFocused = (index) => {
        focusIndex.current = index
    }

    const onVectorCheckboxBlured = (index) => {
        focusIndex.current = null
    }

    const ArrowUpPressed = () => {
        if (focusIndex.current !== null) {
            const _vectors = [];
            setVectors((vectors) => {
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].initializedIndex === focusIndex.current) {
                        vectors[i].y++
                    }
                    _vectors.push(vectors[i]);
                }
                return [..._vectors];
            });
            onAnswerChange([..._vectors]);
        }
    }

    const ShiftArrowUpPressed = () => {
        if (focusIndex.current !== null) {
            const _vectors = [];
            setVectors((vectors) => {
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].initializedIndex === focusIndex.current) {
                        vectors[i].posY++
                    }
                    _vectors.push(vectors[i]);
                }
                return [..._vectors];
            });
            onAnswerChange([..._vectors]);
        }
    }

    const ArrowDownPressed = () => {
        if (focusIndex.current !== null) {
            const _vectors = [];
            setVectors((vectors) => {
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].initializedIndex === focusIndex.current) {
                        vectors[i].y--
                    }
                    _vectors.push(vectors[i]);
                }
                return [..._vectors];
            });
            onAnswerChange([..._vectors]);
        }
    }

    const ShiftArrowDownPressed = () => {
        if (focusIndex.current !== null) {
            const _vectors = [];
            setVectors((vectors) => {
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].initializedIndex === focusIndex.current) {
                        vectors[i].posY--
                    }
                    _vectors.push(vectors[i]);
                }
                return [..._vectors];
            });
            onAnswerChange([..._vectors]);
        }
    }

    const ArrowRightPressed = () => {
        if (focusIndex.current !== null) {
            const _vectors = [];
            setVectors((vectors) => {
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].initializedIndex === focusIndex.current) {
                        vectors[i].x++
                    }
                    _vectors.push(vectors[i]);
                }
                return [..._vectors];
            });
            onAnswerChange([..._vectors]);
        }
    }

    const ShiftArrowRightPressed = () => {
        if (focusIndex.current !== null) {
            const _vectors = [];
            setVectors((vectors) => {
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].initializedIndex === focusIndex.current) {
                        vectors[i].posX++
                    }
                    _vectors.push(vectors[i]);
                }
                return [..._vectors];
            });
            onAnswerChange([..._vectors]);
        }
    }

    const ArrowLeftPressed = () => {
        if (focusIndex.current !== null) {
            const _vectors = [];
            setVectors((vectors) => {
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].initializedIndex === focusIndex.current) {
                        vectors[i].x--
                    }
                    _vectors.push(vectors[i]);
                }
                return [..._vectors];
            });
            onAnswerChange([..._vectors]);
        }
    }

    const ShiftArrowLeftPressed = () => {
        if (focusIndex.current !== null) {
            const _vectors = [];
            setVectors((vectors) => {
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].initializedIndex === focusIndex.current) {
                        vectors[i].posX--
                    }
                    _vectors.push(vectors[i]);
                }
                return [..._vectors];
            });
            onAnswerChange([..._vectors]);
        }
    }

    const onVectorCheckboxClicked = (event, _vector, index) => {
        setPlaneType("");
        setIsInPlane(false);
        setIsOutPlane(false);
        setIsZeroVector(false);
        let checkedValues = vectorsCheckbox
        checkedValues[index] = event.target.checked
        setVectorsCheckbox(checkedValues)
        if (event.target.checked) {
            if(!_vector?.isStaticVector){

                let vectorInitial = {
                    ...vectorInitValue,
                    x: Math.trunc(parseInt(vectorSettings.widthUnit) / 2),
                    y: Math.trunc(parseInt(vectorSettings.heightUnit) / 2),
                    name: _vector.name,
                    color: vectorAnswerFormulas[index].formulaColor,
                    showComponents: vectorAnswerFormulas[index].showComponents,
                    showAngle: vectorAnswerFormulas[index].showAngle,
                    initializedIndex: index,
                    index:index
                }
    
                if (!vectorAnswerFormulas[index].autoOrigin) {
                    vectorInitial.posX = vectorAnswerFormulas[index].xOrigin;
                    vectorInitial.posY = vectorAnswerFormulas[index].yOrigin;
                }
                const newVecArr = [...vectors,
                {
                    ...vectorInitial
                }
                ]
                setVectors([...newVecArr]);
                onAnswerChange([...newVecArr]);
                setClickedBox([...newVecArr]);

                
            } else {
                let vectorAnswer =vectorAnswerFormulas[index]
                let vectorInitial = VectorParser.buildQuestionVariablesMap([vectorAnswer]);
                let staticVector = VectorParser.generateAnswerVector(vectorAnswer, vectorInitial, vectorSettings);
                if (staticVector) {
                    staticVector.isStaticVector = vectorAnswer.isStaticVector
                    staticVector.isIncorrectAnswer = vectorAnswer.isIncorrectAnswer
                    staticVector = {
                      ...staticVector,
                      isStaticVector:vectorAnswer.isStaticVector,
                      isIncorrectAnswer:vectorAnswer.isIncorrectAnswer,
                      name: vectorAnswer.name,
                      color:vectorAnswer.formulaColor,
                      showComponents:vectorAnswer.showComponents,
                      showAngle:vectorAnswer.showAngle,
                      index:index,
                      initializedIndex:index
                    }
                    if (!vectorAnswer.autoOrigin) {
                      staticVector.posX = vectorAnswer.xOrigin;
                      staticVector.posY = vectorAnswer.yOrigin;
                    }
                    const newVecArr = [...vectors,
                        {
                            ...staticVector
                        }
                        ]
                        setVectors([...newVecArr]);
                        setClickedBox([...newVecArr]);
                }
            }
            /* const newVecArr = [...vectors,
            {
                ...vectorInitial
            }
            ]
            console.debug("newVecArr???", newVecArr)
            setVectors([...newVecArr]);
            onAnswerChange([...newVecArr]);
            setClickedBox([...newVecArr]); */
            
            let tempZeroVectorsCheckbox = zeroVectorsCheckbox;
            tempZeroVectorsCheckbox[index] = false;
            setZeroVectorsCheckbox([...tempZeroVectorsCheckbox])
            
        } else {
            setVectors((vectors) => {
                const _vectors = [];
                for (let i = 0; i < vectors.length; i++) {
                    if (vectors[i].name !== _vector.name) {
                        _vectors.push(vectors[i]);
                    }
                }
                if(!_vector?.isStaticVector){
                    onAnswerChange([..._vectors]);
                }
                setClickedBox([..._vectors]);
                return [..._vectors];
            });
        }
    };

    const onPlaneVectorRadioSelected = (val, pickedVectorIndex) => {
        setIsZeroVector(false);
        const _vectors = vectors.map((_vector) => {
            if (_vector.initializedIndex === pickedVectorIndex) {
                if (val === "") {
                    return { ..._vector, x: Math.trunc(parseInt(vectorSettings.widthUnit) / 2), y: Math.trunc(parseInt(vectorSettings.heightUnit) / 2), plane: val }
                }
                return { ..._vector, x: 0, y: 0, plane: val }
                // return {..._vector, plane: val}
            } else {
                return _vector
            }
        })
        setVectors([..._vectors]);


    }

    const handlePlaneSelected = (event, vec) => {
        let value = event.target.value;
        setPlaneType(value);
        onPlaneVectorRadioSelected(value, vec.initializedIndex);
    }


    const handleInPlaneCheckbox = (event, vec) => {
        let value = event.target.checked;
        setIsInPlane(value);
        setIsOutPlane(false);

        let planeType = "";
        if (value === true) {
            planeType = "in-plane";
        }

        onPlaneVectorRadioSelected(planeType, vec.initializedIndex);
    }

    const handleOutPlaneCheckbox = (event, vec) => {
        let value = event.target.checked;
        setIsOutPlane(value);
        setIsInPlane(false);

        let planeType = "";
        if (value === true) {
            planeType = "out-plane";
        }

        onPlaneVectorRadioSelected(planeType, vec.initializedIndex);
    }

    console.log(`Point 0 ::: Free form Grid Settings Data => `, vectorSettings);

    console.log(`Point 0 ::: Correct Answer Vector => `, correctAnswerVectors);

    console.debug("vectorAnswerFormulas>>>", vectorAnswerFormulas, vectors)

    console.debug("freeFormVectorOptions>>>>", freeFormVectorOptions)

    return (
        <div className="py-3">

            <div className="sf-ques-draw-vector-container">

                <div className="position-relative">
                    
                        <div style={{
                            
                        }}>
                            {freeFormVectorOptions?.show_vector_prompt ?
                            <FormControlLabel
                                className="p-0 m-0"
                                onChange={(event) => {
                                    setShowQuestionVectorPrompt(event.target.checked)
                                }}
                                control={<Checkbox size="small" />}
                                label="Show Question Vectors"
                                checked={showQuestionVectorPrompt} />
                            : null}
                            {vectorSettings && vectorSettings.showStudentSnapToGridTickbox ?
                                <div>
                                    <FormControlLabel
                                    className="p-0 m-0"
                                    onChange={(event) => {
                                        setSnapToGrid(event.target.checked);
                                    }}
                                    control={<Checkbox size="small" />}
                                    label="Snap To Grid"
                                    checked={snapToGrid}
                                />
                                </div>
                            : null}
                            {!freeFormVectorOptions?.show_vector_prompt && !(vectorSettings && vectorSettings.showStudentSnapToGridTickbox) ? 
                                <div style={{width:'100%', height:'20px'}}>
                                    {/* hidden div */}
                                </div>
                            : null}
                        </div>
                    <Canvas
                        type="answer"
                        showVectorPrompt={freeFormVectorOptions?.show_vector_prompt}
                        onVectorMoved={onVectorMoved}
                        ref={canvasRef}
                        degStepSize={5}
                        magStepSize={1}
                        stepDeg={false}
                        readOnly={showVectorAnswer}
                        isAnswer={true}
                        height={vectorSettings.height}
                        width={vectorSettings.width}
                        stepSize={vectorSettings.stepSize}
                        rulerXPoint={vectorSettings.rulerXPoint}
                        rulerYPoint={vectorSettings.rulerYPoint}
                        enableGrid={vectorSettings.enableGrid}
                        enableBorder={vectorSettings.enableBorder}
                        enableRuler={vectorSettings.enableRuler}
                        enableDarkGridLine={vectorSettings.enableDarkGridLine}
                        freeBodyDiagram={vectorSettings.image}
                        fbdWidth={vectorSettings.stepSize * vectorSettings.imageWidthUnit}
                        fbdHeight={vectorSettings.stepSize * vectorSettings.imageHeightUnit}
                        fbdX={vectorSettings.imageX}
                        fbdY={vectorSettings.imageY}
                        gridColor={vectorSettings.gridColor}
                        rulerXLabel={vectorSettings.rulerXLabel}
                        rulerYLabel={vectorSettings.rulerYLabel}
                        commonVectorSettings={vectorSettings}
                        vectorAnswerFormulas={vectorAnswerFormulas}
                        isAngleOrMagnitudeTextFieldChanged={isAngleOrMagnitudeTextFieldChanged}
                        handleAngleMagnitudeTextFieldChange={handleAngleMagnitudeTextFieldChange}
                        showQuestionVectorPrompt={showQuestionVectorPrompt}
                        showAnswerResponse={showAnswerResponse}
                        answerCorrect={answerCorrect}
                        rulerNXLabel={vectorSettings.rulerNXLabel}
                        rulerNYLabel={vectorSettings.rulerNYLabel}
                        showScale={vectorSettings.showScale}
                        scale={vectorSettings.scale}
                        snapToGrid={snapToGrid}
                        currentQuestionID={currentQuestionID}
                        onVectorLiveUpdate={onVectorLiveUpdate}
                    ></Canvas>
                </div>
                
                <div className="sf-vector-settings-container h-100">
                    {
                        vectorAnswerFormulas.map((_vector, index) => {
                            let vec = { x: 0, y: 0 };
                            if (vectors && vectors.length) {
                                let index = vectors.findIndex(v => v.name === _vector.name);
                                if (index > -1) {
                                    vec = vectors[index]
                                }
                            }
                            console.debug("VEC---->", _vector.name, vec)
                            return (
                                <FreeFormInput
                                    vectorSettings={vectorSettings}
                                    _vector={_vector}
                                    index={index}
                                    key={index}
                                    vector={vec}
                                    onChange={onChange}
                                    freeFormVectorOptions={freeFormVectorOptions}
                                    onVectorCheckboxClicked={onVectorCheckboxClicked}
                                    onZeroVectorCheckboxClicked={onZeroVectorCheckboxClicked}
                                    onVectorCheckboxFocused={onVectorCheckboxFocused}
                                    onVectorCheckboxBlured={onVectorCheckboxBlured}
                                    isChecked={vectorsCheckbox[index]}
                                    isZeroChecked={zeroVectorsCheckbox[index]}
                                    snapToGrid={snapToGrid}
                                    registerLiveUpdate={(callback) => {
                                        liveVectorCallbacksRef.current[_vector.name] = callback;
                                    }}
                                />
                            )
                        })
                    }
                </div>
            </div>
            <section className="mt-5" aria-labelledby="how-to-enter-answer-heading">
                <div id="how-to-enter-answer-heading" role="heading" aria-level="3" className="font-weight-bold fontClass-14">How to enter the answer:</div>
                <ol id="how-to-enter-answer-instructions" className="fontClass-14 mt-1">
                    <li>Select the vector to display</li>
                    <li>Click and drag the tip of the vector / enter values below to change vector. </li>
                    <li>If you require more space, click and drag the stem of the vector to move it.</li>
                    <li>If you prefer using the keyboard, please refer to the keyboard shortcuts at the top of the page.</li>
                </ol>
            </section>
        </div>
    );
};



const calcAngleDegrees = (x, y) => {
    return Math.round((Math.atan2(y, x) * 180) / Math.PI * 10) / 10;
};

const calculateMagnitude = (x, y) => {
    const magnitude = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    return Math.round(magnitude * 10) / 10;
};

const generateVectorComponents = (angle, mag) => {
    console.log('angle, mag', angle, mag);
    return {
        x: Math.cos(angle * (Math.PI / 180)) * parseFloat(mag),
        y: Math.sin(angle * (Math.PI / 180)) * parseFloat(mag),
    };
};

/* const onAngleMagChanged = (angle,magnitude,onVectorValueChange) => {
  const {x,y} = generateVectorComponents(angle,magnitude);
  onVectorValueChange('x',x);
  onVectorValueChange('y',y);
} */

const onAngleMagChanged = (angle, magnitude, vector, index, onChange) => {
    const { x, y } = generateVectorComponents(angle, magnitude);
    const _vector = { ...vector };
    _vector["x"] = parseFloat(x);
    _vector["y"] = parseFloat(y);
    _vector['index'] = index;
    _vector["angle"] = parseFloat(angle);
    _vector["mag"] = magnitude;
    console.debug("_vector=========", _vector)
    onChange(_vector, "angleMag");
}


const FreeFormInput = ({ _vector, index, vector, onChange, freeFormVectorOptions, onVectorCheckboxClicked, isChecked, onZeroVectorCheckboxClicked, onVectorCheckboxFocused, onVectorCheckboxBlured, isZeroChecked, vectorSettings, snapToGrid, registerLiveUpdate }) => {
    const { name } = _vector;
    const { x = 0, y = 0, z = 0 } = vector;
    const [angle, setAngle] = useState(0);
    const [magnitude, setMagnitude] = useState(0);
    const [checked, setChecked] = useState(false);
    const [zeroChecked, setZeroChecked] = useState(false);

    // Track effective snapToGrid in a ref so the DOM callback always reads the latest value
    const isAngleMag = _vector.formulaType === "angle-magnitude";
    const effectiveSnapRef = useRef(isAngleMag ? false : snapToGrid);
    effectiveSnapRef.current = isAngleMag ? false : snapToGrid;

    useEffect(() => {
        if (registerLiveUpdate) {
            // Direct DOM manipulation — zero React overhead during drag
            registerLiveUpdate((data) => {
                if (!data) return;
                const snap = effectiveSnapRef.current;
                const xyPrec = snap ? 0 : 2;
                const xEl = document.getElementById(`vector-${index}-x`);
                const yEl = document.getElementById(`vector-${index}-y`);
                const angleEl = document.getElementById(`vector-${index}-angle`);
                const magEl = document.getElementById(`vector-${index}-magnitude`);
                if (xEl) xEl.value = xyPrec === 0 ? String(Math.round(data.x)) : parseFloat(data.x).toFixed(xyPrec);
                if (yEl) yEl.value = xyPrec === 0 ? String(Math.round(data.y)) : parseFloat(data.y).toFixed(xyPrec);
                if (angleEl) angleEl.value = parseFloat(data.angle).toFixed(1);
                if (magEl) magEl.value = parseFloat(data.mag).toFixed(2);
            });
        }
        return () => {
            if (registerLiveUpdate) registerLiveUpdate(null);
        };
    }, []);

    useEffect(() => {
        setChecked(isChecked);
    }, [isChecked])

    useEffect(() => {
        setZeroChecked(isZeroChecked);
    }, [isZeroChecked])

    const onVectorValueChange = (key, value) => {
        const _vector = { ...vector };
        _vector[key] = parseFloat(value);
        _vector['index'] = index;
        console.debug("_vector.targetIndex", _vector.index)
        onChange(_vector);
    };

    useEffect(() => {
        let tempX = x;
        let tempY = y;
        if (snapToGrid) {
            tempX = Math.round(tempX);
            tempY = Math.round(tempY);
        }
        setAngle(calcAngleDegrees(tempX, tempY));
        setMagnitude(calculateMagnitude(tempX, tempY));
    }, [x, y, snapToGrid]);


    let fieldDisabled = true;
    if (!snapToGrid) {
        fieldDisabled = false;
    }
    if (_vector.formulaType === "angle-magnitude") {
        snapToGrid = false;
        fieldDisabled = false;
    }

    return (
        <div className="sf-vector-settings" key={name}>
            <div className='font-weight-bold fontClass-18'>
                <div className="d-flex justify-content-start align-items-center">
                    {/* <Checkbox
                        size="small"
                        checked={isChecked}
                        onChange={(event) => {
                            console.debug("event.target.checked", event.target.checked)
                            onVectorCheckboxClicked(event, _vector, index)
                        }}
                    /> */}
                    {/* <div style={{
                        width: '20px',
                        height: '20px',
                        background: _vector.formulaColor,
                        borderRadius: '10px'
                    }}>

                    </div> */}

                     <ReactSVG
                        src={arrowSVG}
                        alt="a"
                        style={{ fill: _vector.formulaColor }}
                        beforeInjection={(svg) => {
                            svg.classList.add("arrow-svg");
                            svg.setAttribute(
                                "style",
                                `fill: ${_vector.formulaColor}`
                            );
                        }}
                    />

                    <FormControlLabel
                        className="p-0 m-0"
                        onChange={(event) => {
                            console.debug("event.target.checked", event.target.checked)
                            onVectorCheckboxClicked(event, _vector, index)
                        }}
                        onFocus={() => onVectorCheckboxFocused(index)}
                        onBlur={()=> onVectorCheckboxBlured(index)}
                        checked={checked}
                        control={
                            <Checkbox
                                size="small"
                                inputProps={{
                                    'aria-label': `Select vector ${index + 1}`,
                                    'aria-describedby': index === 0 ? 'how-to-enter-answer-instructions' : undefined
                                }}
                                sx={{
                                    '&.Mui-focusVisible': {
                                        outline: '3px solid #1D1D1D',
                                        outlineOffset: '2px',
                                        borderRadius: '2px'
                                    }
                                }}
                                icon={
                                    <MdCheckBoxOutlineBlank
                                    style={{
                                        fontSize: 18,
                                        color: _vector.formulaColor,   // border color
                                    }}
                                    />
                                }
                                checkedIcon={
                                    <MdCheckBox
                                    style={{
                                        fontSize: 18,
                                        color: _vector.formulaColor,   // fill color when checked
                                    }}
                                    />
                                }/>
                        }
                        label={
                            <MathJax disableKeyboardNavigation math={_vector && _vector.name ? String.raw`$${_vector.name}$` : ''} />
                        }
                    />
                    {/* <MathJax math={_vector && _vector.name ? String.raw`$${_vector.name}$` : ''} className="options-vector" /> */}
                </div>
            </div>
            {/* <div className='sf-vector-setting'>
                <label htmlFor='showangle'>Show Angle</label>
                <Checkbox size='small' name='showangle' id="showangle" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='showcomponents'>Show Components</label>
                <Checkbox size='small' name='showcomponents' id="showcomponents" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='showcomponents2'>Show Components (From Origin)</label>
                <Checkbox size='small' name='showcomponents2' id="showcomponents2" />
            </div> */}
            {!_vector?.isStaticVector ? 
            
                <div className={`sf-vector-setting`+ index} style={{
                    display: isChecked ? 'block' : 'none'
                }}>
                    <label htmlFor={`zerovector`+ index}>Vector is zero</label>
                    <Checkbox size='small' name={`zerovector`+ index} id={`zerovector`+ index} 
                    checked={zeroChecked}
                    onChange={(event) => {
                        onZeroVectorCheckboxClicked(event, index)
                    }} 
                    />
                </div>
             : ''}
            <div className='sf-vector-setting'>
                {freeFormVectorOptions.show_components &&
                    <label htmlFor={`vector-${index}-x`}>
                        <MathJax disableKeyboardNavigation math={String.raw`$x$`} />
                    </label>
                }
                {freeFormVectorOptions.show_components ?
                    <SFVectorInput
                        value={x}
                        onUpdate={newVal => onVectorValueChange("x", newVal)}
                        precision={snapToGrid ? 0 : 2}
                        type="x"
                        step={snapToGrid ? 1 : 0.01}
                        id={`vector-${index}-x`}
                        ariaLabel={`Vector ${index + 1} x component`}
                    />
                : null}
            </div>

            <div className='sf-vector-setting'>
                {freeFormVectorOptions.show_components &&
                    <label htmlFor={`vector-${index}-y`}>
                        <MathJax disableKeyboardNavigation math={String.raw`$y$`} />
                    </label>
                }
                {freeFormVectorOptions.show_components ?
                    <SFVectorInput
                        value={y}
                        onUpdate={newVal => onVectorValueChange("y", newVal)}
                        precision={snapToGrid ? 0 : 2}
                        type="y"
                        step={snapToGrid ? 1 : 0.01}
                        id={`vector-${index}-y`}
                        ariaLabel={`Vector ${index + 1} y component`}
                    />
                : null}
            </div>
            <div className='sf-vector-setting'>
                {freeFormVectorOptions.show_magnitude_angle ? 
                
                <div className="d-flex">
                    <SFTooltip text="From the positive x-axis">
                        <IconButton
                            aria-label="Angle is measured from the positive x-axis"
                            size="small"
                            sx={{
                                padding: 0,
                                marginRight: '4px',
                                '&.Mui-focusVisible': {
                                    outline: '3px solid #1D1D1D',
                                    outlineOffset: '2px'
                                }
                            }}
                        >
                            <IoInformationCircleSharp aria-hidden="true" fontSize={14} color="#666" />
                        </IconButton>
                    </SFTooltip>
                    <label htmlFor={`vector-${index}-angle`}>
                        <MathJax disableKeyboardNavigation math={String.raw`$angle$`} />
                    </label>
                </div>
                : null
                }
                {freeFormVectorOptions.show_magnitude_angle ? 
                    <SFVectorInput 
                        value={angle}
                        onUpdate={newVal => {
                            onAngleMagChanged(newVal, magnitude, vector, index, onChange)
                        }}
                        disabled={fieldDisabled}
                        precision={1}
                        type="angle"
                        step={snapToGrid ? 1 : 0.1}
                        id={`vector-${index}-angle`}
                        ariaLabel={`Vector ${index + 1} angle`}
                    />
                : null}
            </div>
            <div className='sf-vector-setting'>
                {freeFormVectorOptions.show_magnitude_angle &&
                    <label htmlFor={`vector-${index}-magnitude`}>
                        <MathJax disableKeyboardNavigation math={String.raw`$mag$`} />
                    </label>
                }
                {freeFormVectorOptions.show_magnitude_angle ? 
                    <SFVectorInput 
                        value={magnitude}
                        onUpdate={newVal => {
                            onAngleMagChanged(angle, newVal, vector, index, onChange);
                        }}
                        disabled={fieldDisabled}
                        precision={2}
                        canBeNegative={false}
                        type="mag"
                        step={snapToGrid ? 1 : 0.1}
                        id={`vector-${index}-magnitude`}
                        ariaLabel={`Vector ${index + 1} magnitude`}
                    />
                : null}
            </div>
        </div>
    );
};

const FreeFormInputForDrawVector = ({ _vector, index, vector, onChange, freeFormVectorOptions, onVectorCheckboxClicked, isChecked, onZeroVectorCheckboxClicked, onVectorCheckboxFocused, onVectorCheckboxBlured }) => {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(isChecked);
    }, [isChecked])


    return (
        <div key={name}>
            <div className='font-weight-bold fontClass-18'>
                <div className="d-flex justify-content-start align-items-center">

                    <div style={{
                        width: '15px',
                        height: '15px',
                        background: _vector.formulaColor,
                        borderRadius: '10px'
                    }}>

                    </div>
                    <FormControlLabel
                        className="p-0 m-0"
                        onChange={(event) => {
                            console.debug("event.target.checked", event.target.checked)
                            onVectorCheckboxClicked(event, _vector, index)
                        }}
                        onFocus={() => onVectorCheckboxFocused(index)}
                        onBlur={()=> onVectorCheckboxBlured(index)}
                        control={<Checkbox
                            checked={checked}
                            size="small"
                        />}
                        label={
                            <MathJax math={_vector && _vector.name ? String.raw`$${_vector.name}$` : ''} />
                        }
                    />
                   
                </div>
            </div>
        </div>
    );
};
// Vector Settings

const VectorSetting = () => {

    return (
        <div className='sf-vector-settings'>
            <div className='font-weight-bold fontClass-18'>"A" Vector Settings</div>
            <div className='sf-vector-setting'>
                <label htmlFor='showangle'>Show Angle</label>
                <Checkbox size='small' name='showangle' id="showangle" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='showcomponents'>Show Components</label>
                <Checkbox size='small' name='showcomponents' id="showcomponents" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='showcomponents2'>Show Components (From Origin)</label>
                <Checkbox size='small' name='showcomponents2' id="showcomponents2" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='zerovector'>Zero Vector</label>
                <Checkbox size='small' name='zerovector' id="zerovector" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='x'>X</label>
                <input type="number" name='x' id="x" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='y'>Y</label>
                <input type="number" name='y' id="y" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='angle'>Angle</label>
                <input type="number" name='angle' id="angle" />
            </div>
            <div className='sf-vector-setting'>
                <label htmlFor='magnitude'>Magnitude</label>
                <input type="number" name='magnitude' id="magnitude" />
            </div>
        </div>
    );
}



export default SFVectorTypeAnswer;
